import axios from 'axios'
import store from '../store'
// import { Toast } from 'vant'
// import { logout } from '@/api/common'
import { WXlogin } from '@/utils/WXlogin'
import { removeLocalStore } from '@/utils/index'

const TOKEN_MARK = 'GATEWAY-SESSION'

// 超时时间
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 路由守卫
service.interceptors.request.use((config) => {
  if (config.loading) {
    store.commit('addLoadingNum')
  }
  // token携带
  if (localStorage[TOKEN_MARK]) { config.headers[TOKEN_MARK] = localStorage[TOKEN_MARK] }
  return config
}, (error) => {
  store.commit('subLoadingNum')
  return Promise.reject(error)
})
// 控制用户登陆时效
service.interceptors.response.use((response) => {
  if (response.config.loading) {
    store.commit('subLoadingNum')
  }
  const res = response.data

  if (!localStorage[TOKEN_MARK] && response.headers['gateway-session']) {
    localStorage[TOKEN_MARK] = response.headers['gateway-session']
  }

  return Promise.resolve(res)
},
error => {
  store.commit('subLoadingNum')
  if (error.response.status === 401) {
    // Toast('token 失效，请重新登录')
    removeLocalStore('userinfo')
    removeLocalStore('GATEWAY-SESSION')
    // localStorage.clear()
    WXlogin()
    return
  }

  return Promise.reject(error)
})

// 通讯方法
const axiosFun = (command, parameter = {}, loading = false, json = false) => {
  return service({
    url: '/api/platform/v1',
    method: 'post',
    loading,
    headers: {
      'Content-Type': json ? 'application/json' : 'application/x-www-form-urlencoded'
    },
    data: {
      body: parameter,
      header: {
        command: command,
        version: '1.0'
      }
    }
  })
}

export default axiosFun
